import { assertEvent, assign } from 'xstate';

import { type LocationSearchMachineAction } from '../../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const setFocusedPinId: LocationSearchMachineAction = assign(({ event }) => {
  assertEvent(event, 'SET_FOCUSED_PIN_ID');

  return { focusedPinId: event.id };
});

export const setFocusedCardId: LocationSearchMachineAction = assign(({ event }) => {
  assertEvent(event, 'SET_FOCUSED_CARD_ID');

  return { focusedLocationId: event.id };
});

export const clearFocusedLocations: LocationSearchMachineAction = assign({
  focusedPinId: () => undefined,
  focusedLocationId: () => undefined,
});
